import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger, Dropdown, Popover } from "react-bootstrap";
import $ from 'jquery'; 
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import OrderPostpond from '../../../modal/Corporate_Management/Manage_Corporate/OrderPostpond';
import OrderCancelled from '../../../modal/Corporate_Management/Manage_Corporate/OrderCancelled';
import OrderPayment from '../../../modal/Corporate_Management/Manage_Corporate/OrderPayment';
import OrderConfirm from '../../../modal/Corporate_Management/Manage_Corporate/OrderConfirm';
import HeadCount from '../../../modal/Corporate_Management/Manage_Corporate/HeadCount';
import { toast } from 'react-toastify';
import axios from 'axios';
import moment from "moment";
import DatePicker from "react-multi-date-picker";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Corporates = () => { 

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const tableRef = useRef(null);
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const ImgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;
    const [perPage, setPerPage] = useState(25);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [total_entries, setTotalEntries] = useState(0);
    const [selectedOrder, setSelectedOrder] = React.useState(null);
    const [selecteDate, setSelectedDate] = useState(null);
    const [selectecount, setSelectedcount] = useState(null);
    const [yeardisplay, setyeardisp] = useState(new Date());

    const closeModal = async () => {
        setOpen(false);
        setSelectedOrder(null);
    };

    const handleOrderCancelled = (order) => {
        setSelectedOrder(order);
        setModalType("OrderCancelled");
        setOpen(true);
    };

    const handleOrderPayment = (order) => {
        setSelectedOrder(order);
        setModalType("OrderPayment");
        setOpen(true);
    };

    const handleOrderConfirm = (order) => {
        setSelectedOrder(order);
        setModalType("OrderConfirm");
        setOpen(true);
    };

    const handleHeadcount = (order, date, count) => {
        setSelectedOrder(order);
        setSelectedDate(date);
        setSelectedcount(count);
        setModalType("HeadCount");
        setOpen(true);
    };
 
    const downloadInvoiceDirect = (relativePath) => {
        if (!relativePath) {
            toast.error("Invoice path is missing.");
            return;
        }
        const fileUrl = `${ImgBaseUrl}/${relativePath.replace(/\\/g, '/')}`;
        window.open(fileUrl, '_blank'); // Opens in new tab
    };

 

    const [daysInMonth, setDaysInMonth] = useState([]);

    const generateDaysInMonth = (selectedDate) => {
        const startOfMonth = moment(selectedDate).startOf("month");
        const endOfMonth = moment(selectedDate).endOf("month");

        const days = [];
        let day = startOfMonth.clone();

        while (day.isSameOrBefore(endOfMonth, "day")) {
            days.push(day.clone());
            day.add(1, "day");
        }

        return days;
    };

    useEffect(() => {
        const days = generateDaysInMonth(yeardisplay);
        setDaysInMonth(days);
    }, [yeardisplay]);

    // format date display
    const formatDateDisp = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const [calenOrrder, setCalOrd] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [loading, setLoading] = useState(true);

    const fetchData = () => {
        const params = {
            month: yeardisplay.getMonth() + 1,
            year: yeardisplay.getFullYear(),
            page,
            per_page: perPage,
            search: searchTerm,
            branch_id: branch_id,
            user_id: user_id
        };
        axios.get(`${BaseUrl}/manage_corporate_order/calendar`, { params: params })
            .then(response => {
                setCalOrd(response.data.data);
                setTotalEntries(response.data.total);
                setTotalPages(response.data.last_page);
                setHasFetched(true);
                setLoading(false);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [perPage, page, searchTerm, yeardisplay]);

    const renderItemsCell = (itemsWithQty, status, headcount, isdiff, order, date) => {
        if (!itemsWithQty || itemsWithQty.length === 0)
            return (
                <div className="text-muted text-center small">
                    No Items
                </div>
            );

        const totalItems = itemsWithQty.length;

        // Popover layout (clean, card-like)
        const popoverContent = (
            <Popover id="popover-products" className="toltip-popover" style={{ maxWidth: "230px" }}>
                <Popover.Header as="h6" className="fw-bold text-white text-center py-2 bg-primary">
                    Items ({totalItems})
                </Popover.Header>
                <Popover.Body>
                    {itemsWithQty.map((product, idx) => (
                        <div
                            key={idx}
                            className="py-1 px-1 border-bottom small fw-semibold text-black fs-7"
                            style={{ fontSize: "12px" }}
                        >
                            {product}
                        </div>
                    ))}
                </Popover.Body>
            </Popover>
        );

        const getStatusBadge = () => {
            switch (status) {
                case "delivered":
                    return <Badge bg="success" className="px-2 py-1 text-black fs-8">DELIVERED</Badge>;
                case "pending":
                    return <Badge bg="warning" text="black" className="px-2 py-1 fs-8">SCHEDULED</Badge>;
                case "cancelled":
                    return <Badge bg="danger" className="px-2 py-1 text-white">Cancelled</Badge>;
                default:
                    return <Badge bg="secondary" className="px-2 py-1 text-uppercase">{status}</Badge>;
            }
        };

        return (
            <div className="d-flex flex-column align-items-start gap-1">

                {/* Hover Popover - Items Count */}
                <OverlayTrigger
                    trigger={["hover", "focus", "click"]}
                    placement="bottom"
                    overlay={popoverContent}
                >
                    <div className="cursor-pointer fw-semibold text-primary">
                        {totalItems} Item{totalItems > 1 ? "s" : ""}
                    </div>
                </OverlayTrigger>

                {/* Headcount Badge */}
                <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="bottom"
                    overlay={
                        <Tooltip className="toltip-popover">
                            <span className="small fw-semibold">Head Count</span>
                        </Tooltip>
                    }
                >
                    <Badge bg={isdiff === 1 ? "danger" : "info"} className="px-2 py-1 small cursor-pointer" onClick={() => handleHeadcount(order, date, headcount)}>
                        <span style={{ fontSize: "12px" }}>{headcount}</span>
                    </Badge>
                </OverlayTrigger>

                {/* Status Badge */}
                <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="bottom"
                    overlay={
                        <Tooltip className="toltip-popover">
                            <span className="small fw-semibold">Delivery Status</span>
                        </Tooltip>
                    }
                >
                    <div className="mt-1">
                        {getStatusBadge()}
                    </div>
                </OverlayTrigger>

            </div>
        );
    };

    const blinkingStyle = {
        animation: "blink 3s infinite",
    };

    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    pageLength: 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    return (
        <>
            <style>
                {`
                    @keyframes zoomInOut {
                    0%, 100% {
                        transform: scale(1);
                        filter: drop-shadow(0 0 0px rgba(255, 0, 0, 0.5));
                    }
                        50% {
                            transform: scale(1.15);
                            filter: drop-shadow(0 0 8px rgba(245, 184, 184, 0.8));
                        }
                    }

                    .zoom-animation {
                        animation: zoomInOut 1.8s ease-in-out infinite;
                    }
                `}
            </style>

            {loading ? (
                <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}><Skeleton width={150} /></h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Skeleton width={70} /></li>
                            <li className="breadcrumb-item"><Skeleton width={20} /></li>
                            <li className="breadcrumb-item active"><Skeleton width={100} /></li>
                        </ol>
                    </div>
                    <div className='d-flex align-items-center gap-3 flex-wrap mb-2'>
                        <Skeleton width={30} height={30} borderRadius={12} />
                        <Skeleton width={100} />
                        <Skeleton width={30} height={30} borderRadius={12} />
                        <Skeleton width={100} />
                    </div>
                </div>
            ) : (
                <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                    {open && modalType === "OrderPostpond" && (
                        <OrderPostpond
                            show={open}
                            onClose={closeModal}
                            order={selectedOrder}          // Pass order here
                        />
                    )}
                    {open && modalType === "OrderCancelled" && (
                        <OrderCancelled
                            show={open}
                            onClose={closeModal}
                            order={selectedOrder}
                        />
                    )}
                    {open && modalType === "OrderPayment" && (
                        <OrderPayment
                            show={open}
                            order={selectedOrder}
                            onClose={closeModal}
                        />
                    )}
                    {open && modalType === "OrderConfirm" && (
                        <OrderConfirm
                            show={open}
                            order={selectedOrder}
                            onClose={closeModal}
                            refresh={fetchData}
                        />
                    )}
                    {open && modalType === "HeadCount" && (
                        <HeadCount
                            show={open}
                            onClose={closeModal}
                            order={selectedOrder}
                            date={selecteDate}
                            count={selectecount}
                            refresh={fetchData}
                        />
                    )}

                    <div className='mb-0'>
                        <div className="mb-0 px-0">
                            <h4 className='breadcrumb-header'>Manage Corporate Orders</h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                            <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                            <li className="breadcrumb-item active">Corporate Management</li>
                        </ol>
                    </div>
                    <div className="d-flex flex-row align-items-center justify-content-between gap-2 bg-gray-300 border border-gray-700 py-2 px-2 rounded">
                        <div className="d-flex flex-row align-items-center justify-content-center gap-2">
                            <label className='py-3 px-3 rounded border border-gray-700' style={{ backgroundColor: '#dde2ff' }}></label>
                            <span>-</span>
                            <label className='text-black font-w600 fs-7'>Order Not Yet Confirmed</label>
                        </div>
                        <span>|</span>
                        <div className="d-flex flex-row align-items-center justify-content-center gap-2">
                            <label className='py-3 px-3 rounded border border-gray-700' style={{ backgroundColor: '#d0fff0' }}></label>
                            <span>-</span>
                            <label className='text-black font-w600 fs-7'>Payment Completed</label>
                        </div>
                        <span>|</span>
                        <div className="d-flex flex-row align-items-center justify-content-center gap-2">
                            <label className='py-3 px-3 rounded border border-gray-700' style={{ backgroundColor: '#FF857D' }}></label>
                            <span>-</span>
                            <label className='text-black font-w600 fs-7'>Order Cancelled</label>
                        </div>
                    </div>
                </div>
            )}

            {loading ? (
                <div className="row mb-3">
                    <div className="d-flex justify-content-between w-100">

                        {/* Left Summary Boxes */}
                        <div className="d-flex flex-wrap">
                            {[1].map((_, index) => (
                                <div className="me-2 mb-2" key={index}>

                                    {/* Number */}
                                    <div className="mt-2">
                                        <Skeleton width={200} height={30} />
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            ) : (
                <div className='col-lg-12 mb-2'>

                    <div className='row'>

                        {/* month filter */}
                        <div className="col-lg-3 mb-2">
                            <label className="text-black font-w500 fs-7"></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker format="MMM-YYYY" value={yeardisplay} calendarPosition="top" mode="single" onlyMonthPicker={true} minDate={new Date(1900, 0, 1)} onChange={(date) => setyeardisp(new Date(date))} />
                                <div className='input-group-text bg-transparent border-0 px-0 py-0' style={{ padding: 0, margin: 0, display: 'flex', alignItems: 'center' }}><i class="fa-solid fa-caret-down fs-4"></i></div>
                            </div>
                        </div>
                    </div>

                </div>
            )}

            {loading ? (
                <div className="table-container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2"><Skeleton width={50} height={25} /></label>
                            <Skeleton width={50} height={25} className="mb-1" />
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <Skeleton width={150} height={25} className="mb-1" />
                        </div>
                    </div>

                    <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            {[...Array(perPage)].map((_, i) => (
                                <tr key={i}>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            <Skeleton width={180} height={15} />
                        </div>

                        {/* Bottom right: Pagination */}
                        <nav>
                            <div className="d-flex gap-2">
                                {[...Array(4)].map((_, i) => (
                                    <Skeleton key={i} width={40} height={25} borderRadius={5} />
                                ))}
                            </div>
                        </nav>
                    </div>
                </div>
            ) : (
                <div className="table-container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{ fontSize: '0.85rem', height: '30px' }}
                                value={perPage}
                                onChange={e => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1);
                                }}
                            >
                                {[10, 25, 50, 100].map(size => (
                                    <option key={size} value={size}>
                                        {size}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <input
                                type="text"
                                style={{ fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                                value={searchTerm}
                                onChange={e => {
                                    setSearchTerm(e.target.value);
                                    setPage(1);
                                }}
                            />
                        </div>
                    </div>

                    <div style={{ overflowX: "auto" }}>
                        <table className="table table-bordered align-middle text-center">
                            <thead>
                                <tr className="text-start text-white fw-bold fs-6 gs-0 th_head">
                                    <th className='bg-primary text-center'
                                        style={{
                                            minWidth: "220px",
                                            position: "sticky",
                                            left: 0,
                                            zIndex: 2,
                                        }}
                                    >
                                        Order Details
                                    </th>
                                    {daysInMonth.map((d) => (
                                        <th key={d.format("YYYY-MM-DD")} style={{ minWidth: "120px" }} className='text-center'>
                                            {d.format("DD MMM ddd")}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {calenOrrder.map((order) => (
                                    <tr key={order.id} >
                                        {/* Fixed first column */}
                                        <td
                                            style={{
                                                position: "sticky",
                                                left: 0,
                                                backgroundColor: order.order_status == 1 ? '#dde2ff' : order.order_status == 8 ? '#d0fff0' : ["4", "9", "10"].includes(order.order_status) ? '#FF857D' : '#f8f9fa',
                                                zIndex: 1,
                                                verticalAlign: "top",
                                                paddingRight: "20px"
                                            }}
                                        >
                                            <div className='d-flex flex-column'>
                                                {/* details */}
                                                <div className='d-flex flex-column'>

                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Order ID: {order.catering_id} <br></br> Ordered Date: {order.ordered_date ? formatDateDisp(order.ordered_date) : ''}</span></Tooltip>} >
                                                        <label className="text-black font-w600 fs-7 text-wrap text-start text-wrap text-start">{order.catering_id}</label>
                                                    </OverlayTrigger>

                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Customer Name: {order.customer?.customer_name} <br></br>Customer Number: {order.customer?.customer_number}<br></br>Company Name: {order.customer?.company_name} <br></br>Company Number: {order.customer?.company_number}</span></Tooltip>} >
                                                        <label className="text-black font-w600 fs-7 text-wrap text-start text-wrap">{order.customer?.customer_name} ({order.customer?.customer_number})</label>
                                                    </OverlayTrigger>

                                                    <div className='d-flex justify-content-left align-items-left'>
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Start Date: {order.start_date ? formatDateDisp(order.start_date) : ''} <br></br> End Date: {order.end_date ? formatDateDisp(order.end_date) : ''} <br></br> Delivery Time: {order.delivery_time ? order.delivery_time : ''}</span></Tooltip>} >
                                                            <label className='text-primary text-start py-1 px-1 fw-bold fs-7'>{order.start_date ? formatDateDisp(order.start_date) : ''}</label>
                                                        </OverlayTrigger>
                                                        <label className='text-black text-start py-1 px-1 fs-7'>-</label>
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Start Date: {order.start_date ? formatDateDisp(order.start_date) : ''} <br></br> End Date: {order.end_date ? formatDateDisp(order.end_date) : ''} <br></br> Delivery Time: {order.delivery_time ? order.delivery_time : ''}</span></Tooltip>} >
                                                            <label className='text-danger text-start py-1 px-1 fw-bold fs-7'>{order.end_date ? formatDateDisp(order.end_date) : ''}</label>
                                                        </OverlayTrigger>
                                                    </div>
                                                </div>

                                                {/* action */}
                                                <div className='d-flex flex-column'>
                                                    <div className='d-flex justify-content-left align-items-left'>
                                                        {/* payment pending */}
                                                        {order.total != order.paid_amount && order.order_status != 4 && order.order_status != 1 && (
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Payment</span></Tooltip>} >
                                                                <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleOrderPayment(order)}>
                                                                    <style>
                                                                        {`@keyframes blink {
                                                                    0%, 50%, 100% { opacity: 1; }
                                                                    25%, 75% { opacity: 0; }
                                                                }`}
                                                                    </style>
                                                                    <span style={blinkingStyle}><i class="fa-solid fa-indian-rupee-sign fs-5 mt-1 text-danger"></i></span>
                                                                </Button>
                                                            </OverlayTrigger>
                                                        )}

                                                        {/* confirm order */}
                                                        {order.order_status == 1 && (
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Confirm Order</span></Tooltip>} >
                                                                <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleOrderConfirm(order)}>
                                                                    <span><i class="fa-solid fa-calendar-check fs-5 mt-1"></i></span>
                                                                </Button>
                                                            </OverlayTrigger>
                                                        )}

                                                        {/* cancel order */}
                                                        {["1", "2", "5", "8"].includes(order.order_status) && (
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Cancel</span></Tooltip>} >
                                                                <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleOrderCancelled(order)}>
                                                                    <span><i class="fa-solid fa-circle-xmark fs-5 mt-1"></i></span>
                                                                </Button>
                                                            </OverlayTrigger>
                                                        )}

                                                        {/* postpone */}
                                                        {/* <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Postpone</span></Tooltip>} >
                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" >
                                                        <span><i class="fa fa-clock fs-6 mt-1"></i></span>
                                                    </Button>
                                                    </OverlayTrigger> */}

                                                        {/* invoce */}
                                                        {order.invoice && (
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Invoice</span></Tooltip>} >
                                                                <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => downloadInvoiceDirect(order.invoice)}>
                                                                    <span><i class="fa-solid fa-file-alt fs-5 mt-1"></i></span>
                                                                </Button>
                                                            </OverlayTrigger>
                                                        )}

                                                        {/* view */}
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" as={Link} to="/corporate-order-view" state={{ order }}>
                                                                <span><i class="fa fa-eye fs-6 mt-1"></i></span>
                                                            </Button>
                                                        </OverlayTrigger>

                                                              {/* edit */}
                                                        {/* <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" as={Link} to="/corporate-order-edit" state={{ order }}>
                                                                <span><i class="fa fa-edit fs-6 mt-1"></i></span>
                                                            </Button>
                                                        </OverlayTrigger> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        {daysInMonth.map((day) => {
                                            const schedule = order.deliverySchedule[day.format("YYYY-MM-DD")];
                                            
                                            return (
                                                <td key={day.format("YYYY-MM-DD")} style={{ verticalAlign: "center" }}>
                                                    {schedule ? (
                                                        renderItemsCell(schedule.items, schedule.status, schedule.head_count, schedule.is_diff_count, order, day.format("YYYY-MM-DD"))
                                                    ) : (
                                                        <span className="text-muted">-</span>
                                                    )}
                                                </td>
                                            );
                                        })}


                                    </tr>
                                ))}

                                {calenOrrder.length === 0 && hasFetched && (
                                    <tr>
                                        <td colSpan="1" className="text-center text-muted py-2">
                                            No data available
                                        </td>
                                        <td colSpan={daysInMonth.length} className="text-center text-muted py-2">
                                            -
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                            {calenOrrder.length > 0 ? (
                                <span className="text-muted">
                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + calenOrrder.length} of {total_entries} entries
                                </span>
                            ) : (
                                <span className="text-muted">
                                    Showing 0 to 0 of 0 entries
                                </span>
                            )}
                        </div>

                        <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                {/* Previous Button */}
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                        Previous
                                    </button>
                                </li>

                                {/* First Page */}
                                <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                        1
                                    </button>
                                </li>

                                {/* Left Ellipsis */}
                                {page > 4 && (
                                    <li className="page-item disabled">
                                        <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                    </li>
                                )}

                                {/* Pages Around Current */}
                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                    .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                    .map(p => (
                                        <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                {p}
                                            </button>
                                        </li>
                                    ))}

                                {/* Right Ellipsis */}
                                {page < totalPages - 3 && (
                                    <li className="page-item disabled">
                                        <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                    </li>
                                )}

                                {/* Last Page */}
                                {totalPages > 1 && (
                                    <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                            {totalPages}
                                        </button>
                                    </li>
                                )}

                                {/* Next Button */}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>

                    </div>
                </div>
            )}



        </>
    )


}
export default Corporates;